export default __webpack_public_path__ + "static/media/03AW1SEP66.41fb49c3.jpg";